import { Button, CircularProgress, Modal, Slider, TextField, Typography } from "@mui/material";
import { FormControl, InputLabel, MenuItem, Select, OutlinedInput, Checkbox, ListItemText } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import html2canvas from "html2canvas";
import React, { useEffect, useState } from "react";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import { FaMapMarkerAlt } from "react-icons/fa";

import {
  Brush,
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from "recharts";


import { format } from "date-fns";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Papa from "papaparse";
import { useRef } from "react";
import "./leftbar.css";


const MultiColAnomalyLog = ({ 
  selectedMarker,
  formatDate,
  imdatalogs,
  setimDatalogs,
  getImDatalogs,
  setIsMultiColAnModalOpen,
  handleCloseMultiColAnModal
}) => {
  const [earliestDate, setEarliestDate] = useState("");
  const [latestDate, setLatestDate] = useState("");

  useEffect(() => {
    const fetchDateRange = async () => {
      try {
        const response = await fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/datalogs/${selectedMarker.wellId}/date-range`);
        const data = await response.json();

        if (response.ok) {
          setEarliestDate(data.earliest);
          setLatestDate(data.latest);
        } else {
          console.error(data.message || "Failed to fetch date range.");
        }
      } catch (err) {
        console.error("Error fetching date range:", err);
      }
    };

    fetchDateRange();
  }, [selectedMarker]);



  const [showMinDateModal, setShowMinDateModal] = useState(false);

  const handleCloseMinDateModal = () => {
    setShowMinDateModal(false);
  };


  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    const newEndDate = event.target.value;

    // Only perform validation if both dates are selected
    if (startDate && newEndDate) {
      const start = new Date(startDate);
      const end = new Date(newEndDate);

      // Calculate difference in years
      const diffInMs = end - start;
      const msInYear = 1000 * 60 * 60 * 24 * 365.25; // Account for leap years
      const diffInYears = diffInMs / msInYear;

      if (diffInYears < 2) {
        // If less than 2 years, show the modal and don't update the end date
        setShowMinDateModal(true);
        return;
      }
    }

    // If validation passes or not enough info to validate, update the end date
    setEndDate(newEndDate);
  };


  const [columns, setColumns] = useState([]);
  const [mainColumn, setMainColumn] = useState(""); // for single-select
  const [supportColumns, setSupportColumns] = useState([]); // for multi-select

  useEffect(() => {
    const fetchColumns = async () => {
      try {
    const response = await fetch("https://warpo-dashboard.cse.buet.ac.bd/api/datalogs/multicol/columns");

    console.log("Response status:", response.status);
    const text = await response.text();
    console.log("Raw response body:", text);

    if (!response.ok) throw new Error("Failed to fetch column names");

    const columnNames = JSON.parse(text);
    setColumns(columnNames);
  } catch (error) {
    console.error("Error fetching columns:", error);
  }
    };

    fetchColumns(); // <- this line is outside the async function
  }, []);

  const filteredMainColumns = columns.filter(col => col !== "mTm");
  const filteredSupportColumns = columns.filter(col => col !== "mTm" && col !== mainColumn);

  const handleMainColumnChange = (e) => {
    const newMain = e.target.value;
    setMainColumn(newMain);
  };

  const [AnRate, setAnRate] = useState("");
  const handleAnRateChange = (event) => {
    setAnRate(event.target.value);
  };


  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  const [versions, setVersions] = useState([]); // Store versions data from backend
  const [selectedVersion, setSelectedVersion] = useState("0"); // Selected version number
  const [selectedVersionAnom, setSelectedVersionAnom] = useState("Null"); // Selected version number
  const [tableData, setTableData] = useState([]); // Store the fetched data for the selected version

  const [zoomLevelImDatalogs, setZoomLevelImDatalogs] = useState(0);
  const [startIndexImDatalogs, setStartIndexImDatalogs] = useState(0);
  const [endIndexImDatalogs, setEndIndexImDatalogs] = useState(imdatalogs.length - 1);

  const visibleDataImDatalogs = imdatalogs.slice(
    startIndexImDatalogs,
    endIndexImDatalogs + 1
  );

  const [dataLimitImDatalogs, setDataLimitImDatalogs] = useState(
    visibleDataImDatalogs.length
  );

  const [versionDetails, setVersionDetails] = useState(null);
  const [versionsanom, setVersionsanom] = useState([]); // Store versions data from backend
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isRevertModalOpen, setIsRevertModalOpen] = useState(false);
  const [selectedDataPoint, setSelectedDataPoint] = useState(null);
  const [isLoadingOriginal, setIsLoadingOriginal] = useState(false);
  const [originalError, setOriginalError] = useState(null);
  const [originalValue, setOriginalValue] = useState(null);
  const [isConfirmRevertModalOpen, setIsConfirmRevertModalOpen] = useState(false);

  const fetchOriginalValue = async (dataPoint) => {
    if (!dataPoint) return;
    setIsLoadingOriginal(true);
    setOriginalError(null);
    try {
      const response = await fetch('https://warpo-dashboard.cse.buet.ac.bd/api/get-original-value', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          wellId: dataPoint.wellId,
          mTm: dataPoint.mTm
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to fetch original value');
      }

      const data = await response.json();
      if (data.success) {
        setOriginalValue(data.originalValue.wtr);
      } else {
        throw new Error('Failed to retrieve original value');
      }
    } catch (error) {
      console.error('Error fetching original value:', error);
      setOriginalError(error.message);
    } finally {
      setIsLoadingOriginal(false);
    }
  };

  // Handler for clicking an anomaly-corrected point
  const handleAnomalyPointClick = (dataPoint) => {
    setSelectedDataPoint(dataPoint);
    setIsRevertModalOpen(true);
    fetchOriginalValue(dataPoint);
  };

  // Closing the revert modal
  const handleCloseRevertModal = () => {
    setIsRevertModalOpen(false);
    setSelectedDataPoint(null);
  };

  const handleRevertAnomaly = () => {
    setIsRevertModalOpen(false);
    setIsConfirmRevertModalOpen(true);
  };

  // Handling the final confirmation
  const handleConfirmRevert = async () => {
    if (!selectedDataPoint) return;

    setIsLoading(true);

    try {
      const response = await fetch('https://warpo-dashboard.cse.buet.ac.bd/api/revert-anomaly-correction', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          wellId: selectedMarker.wellId,
          mTm: selectedDataPoint.mTm,
          versionNumber: selectedVersionAnom
        })
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      // Refreshing the data after reversion
      const updatedData = await getImDatalogs(selectedMarker.wellId);

      // Closing all modals
      setIsConfirmRevertModalOpen(false);
      setSelectedDataPoint(null);

      // Showing success message
      alert('Data point successfully reverted to original value');
    } catch (error) {
      console.error('Error reverting anomaly correction:', error);
      alert(`Failed to revert anomaly correction: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  // Closing the confirmation modal
  const handleCloseConfirmRevertModal = () => {
    setIsConfirmRevertModalOpen(false);
  };

  const [sortConfig, setSortConfig] = useState({
    mTm: { direction: "asc" },
    wtr: { direction: "asc" },
    // tmp: { direction: "asc" },
    // prs: { direction: "asc" },
  });

  const chartRef = useRef();

  const [selectedMetric, setSelectedMetric] = useState("wtr"); // Default to Water Level

  const [corrData, setCorrData] = useState({});
  const [isLoadingCorr, setIsLoadingCorr] = useState(false);
  const [corrOrderBy, setCorrOrderBy] = useState('Correlation');
  const [corrOrder, setCorrOrder] = useState('desc');
  const [showCorrTable, setShowCorrTable] = useState(false);

  useEffect(() => {
    if (selectedMarker && selectedMarker.wellId) {
      fetchVersions(selectedMarker.wellId);
    }
  }, [selectedMarker]);
  
  // Render loading indicator
  if (isLoading) {
    return (
      <Modal
        open={isLoading}
        onClose={() => setIsLoading(false)}
        className="loading-modal"
      >
        <div className="loading-content">
          <CircularProgress color="primary" />
          <Typography
            variant="h6"
            style={{ marginTop: "20px", color: "#333333" }}
          >
            Working, Please Wait ...
          </Typography>
          <div className="progress-bar">
            <div className="progress" style={{ width: `${progress}%` }}></div>
          </div>
        </div>
      </Modal>
    );
  }

  

  const resetZoomImDatalogs = () => {
    setStartIndexImDatalogs(0);
    setZoomLevelImDatalogs(0);
    setEndIndexImDatalogs(imdatalogs.length - 1);
  };

  
  // const handleLoadAnomVersion = async (versionNumber) => {
  //   try {
  //     // Fetching version-specific data
  //     const response = await fetch(
  //       `https://warpo-dashboard.cse.buet.ac.bd/api/anomdatalogs_version/${selectedMarker.wellId}/${versionNumber}`
  //     );
  //     const data = await response.json();

  //     if (response.ok) {
  //       setTableData(data);
  //       setimDatalogs(data);

  //       // Reset zoom and visualization settings
  //       resetZoomImDatalogs();
  //       setDataLimitImDatalogs(data.length);
  //     } else {
  //       console.error("Error fetching anomaly corrected data:", data.error);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  const handleLoadAnomVersion = async (versionNumber) => {
    try {
      const response = await fetch(
        `https://warpo-dashboard.cse.buet.ac.bd/api/anomdatalogs_version/${selectedMarker.wellId}/${versionNumber}`
      );
      const data = await response.json();

      if (!response.ok) {
        console.error("Error fetching anomaly corrected data:", data.error);
        return;
      }

      // ✅ Fetch original values for anomaly-corrected points
      const enhancedData = await fetchOriginalValues(data, selectedMarker.wellId);

      setTableData(enhancedData);
      setimDatalogs(enhancedData);

      console.log("ENHANCED DATA: ", enhancedData)

      // Reset zoom and visualization settings
      resetZoomImDatalogs();
      setDataLimitImDatalogs(enhancedData.length);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  

  // Fetching versions based on selected wellId
  const fetchVersions = async (wellId) => {
    try {
      const response = await fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/datalogs_versions/${wellId}`);
      const data = await response.json();

      if (response.ok) {
        const impData = data.filter(item => item.imp_or_anom === 'imp');
        const anomData = data.filter(item => item.imp_or_anom === 'anom');

        setVersions(impData);
        setVersionsanom(anomData);

        // Check if anomaly correction versions exist
        if (anomData.length > 0) {
          // Get the latest anomaly version (assuming the last one in the array is the most recent)
          const latestAnomVersion = anomData[anomData.length - 1];

          // Set the selected version in the dropdown
          setSelectedVersionAnom(latestAnomVersion.version_number);

          // Fetch and load the data for this version
          handleLoadAnomVersion(latestAnomVersion.version_number);
        }
      } else {
        console.error("Error fetching versions:", data.error);
      }
    } catch (error) {
      console.error("Error fetching versions:", error);
    }
  };

  const fetchVersionData = async (wellId, versionNumber) => {
    try {
      const response = await fetch(
        `https://warpo-dashboard.cse.buet.ac.bd/api/imdatalogs_version/${wellId}/${versionNumber}`
      );
      const data = await response.json();

      if (response.ok) {
        setTableData(data);
        setimDatalogs(data);

        // Reset zoom and visualization settings when loading version data
        resetZoomImDatalogs();
        setDataLimitImDatalogs(data.length);
      } else {
        console.error("Error fetching imputed data:", data.error);
      }
    } catch (error) {
      console.error("Error fetching imputed data:", error);
    }
  };


  const handleSubmit = async () => {
    if (!startDate) {
      alert("Please select a start date.");
      return;
    }

    if (!endDate) {
      alert("Please select an end date.");
      return;
    }

    if (startDate > endDate) {
      alert("Start date cannot be after end date.");
      return;
    }

    if (!mainColumn) {
      alert("Please select a main column.");
      return;
    }

    if (!supportColumns || supportColumns.length === 0) {
      alert("Please select at least one support column.");
      return;
    }

    if (!AnRate) {
      alert("Please enter Maximum Deviation Percentage")
    }


    // ✅ All inputs valid — proceed with your logic
    console.log("Inputs are valid:");
    console.log("Start Date:", startDate);
    console.log("End Date:", endDate);
    console.log("Main Column:", mainColumn);
    console.log("Support Columns:", supportColumns);
    console.log("Deviation Percantage:", AnRate);


    if (selectedMarker) {
      setIsLoading(true); // Set loading state to true

      try {
        const response = await fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/send-datalogs-anomaly-bitemporal/${selectedMarker.wellId}/${AnRate}/${selectedVersion}/${startDate}/${endDate}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            "main_col" : mainColumn,
            "support_cols" : ["mTm", ...supportColumns]
          }),
        });
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error || `Request failed with status ${response.status}`);
        }

        const anomalyData = await response.json();
        console.log("Multi Column anomaly correction result:", anomalyData);

        // Fetch updated imputed datalogs and display
        const updatedData = await getImDatalogs(selectedMarker.wellId);

        // Fetch updated versions list to refresh the dropdown
        await fetchVersions(selectedMarker.wellId);

        // Set the latest version as selected
        if (versions.length > 0) {
          setSelectedVersion(versions[versions.length - 1].version_number);
        }

        // // Show success message
        // alert(`Successfully reused imputation: ${result.count} data points updated. Reload the page and select the latest version from the right panel to view the most recent imputed data.`);

        // Open modal only if data was successfully updated
        if (updatedData && updatedData.length > 0) {
          setIsMultiColAnModalOpen(true); // Open modal to show the results
        }

        if (response.status === 404) {
          const errorData = await response.json();
          alert(errorData.error); // Show the error message as a pop-up
          return;
        }

      } catch (err) {
        console.error("Error during Anomaly Correction :", err);
      } finally {
        setIsLoading(false); // Reset loading state once imputation is completed
      }
    }

  };


  const imdownloadAsCSV = () => {
    const options = {
      fields: ["Measurement Time", "Water Level", "Is Anomaly Corrected?"],
      quotes: true 
    };

    
    const customData = imdatalogs.map(row => [
      row.mTm,           
      row.wtr,             
      row.is_anomaly_corrected ? "Yes" : "No"  
    ]);

    // Create CSV with custom field names
    const csv = Papa.unparse({
      fields: options.fields,
      data: customData
    }, options);

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const filename = selectedVersionAnom === "0" ? "raw_datalogs.csv" : `anomaly_datalogs_version_${selectedVersionAnom}.csv`;
    saveAs(blob, filename);
  };

  const imdownloadAsPDF = () => {
    const doc = new jsPDF();
        const tableData = imdatalogs.map((datalog) => [
          datalog.mTm,
          datalog.wtr,
          datalog.is_anomaly_corrected ? "Yes" : "No",
        ]);
    
        doc.text("Datalogs", 14, 10);
        doc.autoTable({
          head: [
            [
              "Measurement Time",
              "Water Level",
              "Is Anomaly Corrected?",
            ],
          ],
          body: tableData,
        });
        const filename = selectedVersionAnom === "0" ? `raw_datalogs_of_well_${selectedMarker.wellId}.pdf` : `anomaly_datalogs_of_well_${selectedMarker.wellId}_version_${selectedVersionAnom}.pdf`;
    
        doc.save(filename);
  };
  
  // Handle version change in dropdown
  const handleVersionChange = async (event) => {
    const versionNumber = event.target.value;
    setSelectedVersion(versionNumber); // Update selected version number
  };

  // const handleVersionChangeAnom = async (event) => {
  //   const versionNumber = event.target.value;
  //   setSelectedVersionAnom(versionNumber);

  //   try {
  //     // Fetching version-specific data
  //     const response = await fetch(
  //       `https://warpo-dashboard.cse.buet.ac.bd/api/anomdatalogs_version/${selectedMarker.wellId}/${versionNumber}`
  //     );
  //     const data = await response.json();

  //     if (response.ok) {
  //       setTableData(data);
  //       setimDatalogs(data);

  //       // Reset zoom and visualization settings
  //       resetZoomImDatalogs();
  //       setDataLimitImDatalogs(data.length);
  //     } else {
  //       console.error("Error fetching anomaly corrected data:", data.error);
  //       alert("Error fetching data for this version");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     alert("Failed to fetch data for this version");
  //   }
  // };


  const handleVersionChangeAnom = async (event) => {
    const versionNumber = event.target.value;
    setSelectedVersionAnom(versionNumber);

    try {
      // Fetching version-specific anomaly-corrected data
      const response = await fetch(
        `https://warpo-dashboard.cse.buet.ac.bd/api/anomdatalogs_version/${selectedMarker.wellId}/${versionNumber}`
      );
      const data = await response.json();

      if (!response.ok) {
        console.error("Error fetching anomaly corrected data:", data.error);
        alert("Error fetching data for this version");
        return;
      }

      // ✅ Fetch original values for anomaly-corrected points
      const enhancedData = await fetchOriginalValues(data, selectedMarker.wellId);

      setTableData(enhancedData);
      setimDatalogs(enhancedData);

      // Reset zoom and visualization settings
      resetZoomImDatalogs();
      setDataLimitImDatalogs(enhancedData.length);
      
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("Failed to fetch data for this version");
    }
  };


  const handleDetailsButtonClickAnom = () => {
    if (selectedVersionAnom) {
      fetchVersionDetailsAnom(selectedMarker.wellId, selectedVersionAnom);
    }
  };

  const fetchVersionDetailsAnom = async (wellId, version) => {
    try {
      const response = await fetch(
        `https://warpo-dashboard.cse.buet.ac.bd/api/get-version-details/${wellId}/${version}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'imp_or_anom': 'anom'
          }
        }
      );
      const data = await response.json();

      if (response.ok) {
        setVersionDetails(data);
        setIsModalOpen(true);
      } else {
        console.error("Error fetching anomaly version details:", data.error);
      }
    } catch (error) {
      console.error("Error fetching anomaly data from backend:", error);
    }
  };

  const fetchVersionDetails = async () => {
    try {
      // Handling raw data (version 0) case
      if (selectedVersion === "0") {
        setVersionDetails({
          wellId: selectedMarker.wellId,
          version_number: "0",
          update_time: new Date().toISOString(),
          comments: "Raw data without any corrections",
          name: "System",
          email: "system@example.com",
          designation: "System",
          contact_no: "-",
          start_date: "",
          end_date: ""
        });
        setIsModalOpen(true);
        return;
      }

      // Handling regular version details
      const response = await fetch(
        `https://warpo-dashboard.cse.buet.ac.bd/api/get-version-details/${selectedMarker.wellId}/${selectedVersion}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'imp_or_anom': 'imp'
          }
        }
      );
      const data = await response.json();

      if (response.ok) {
        setVersionDetails(data);
        setIsModalOpen(true);
      } else {
        console.error("Error fetching version details:", data.error);
      }
    } catch (error) {
      console.error("Error fetching data from backend:", error);
    }
  };

  const CustomDotAnomaly = (props) => {
    const { cx, cy, payload, onClick } = props;

    // Handler for clicking on an anomaly-corrected point
    const handleClick = () => {
      if (payload.is_anomaly_corrected) {
        onClick(payload);
      }
    };

    // If this is an anomaly-corrected point
    if (payload.is_anomaly_corrected) {
      return (
        <>
          {/* Original value (green dot) */}
          {/* {payload.originalValue && (
            <circle
              cx={cx}
              cy={cy - (payload.wtr - payload.originalValue) * 30} // Offset based on difference
              r={5}
              stroke="green"
              strokeWidth={2}
              fill="green"
            />
          )} */}
          {/* Line connecting original and corrected values */}
          {/* {payload.originalValue && (
            <line
              x1={cx}
              y1={cy}
              x2={cx}
              y2={cy - (payload.wtr - payload.originalValue) * 30}
              stroke="green"
              strokeWidth={1.5}
              strokeDasharray="3,3"
            />
          )} */}
          {/* Corrected value (orange dot) */}
          <circle
            cx={cx}
            cy={cy}
            r={5}
            stroke="orange"
            strokeWidth={2}
            fill="orange"
            style={{ cursor: 'pointer' }}
            onClick={handleClick}
          />
        </>
      );
    }

    // Normal data point
    return (
      <circle
        cx={cx}
        cy={cy}
        r={5}
        fill="black"
      />
    );
  };

  const handleDetailsButtonClick = () => {
    if (selectedVersion) {
      fetchVersionDetails(selectedMarker.wellId, selectedVersion); // Fetch details for the selected version
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  
  
  const handleDownload = () => {
    if (chartRef.current) {
      html2canvas(chartRef.current).then((canvas) => {
        const link = document.createElement("a");
        link.download = `multi_column_anomaly_datalogs_of_well_${selectedMarker.wellId}_versions_${selectedVersion}.png`;
        link.href = canvas.toDataURL();
        link.click();
      });
    }
  };

  const handleZoomImDatalogs = (event, newValue) => {
    setZoomLevelImDatalogs(newValue);
    const range = imdatalogs.length;
    const zoomFactor = newValue / 100;

    const newStart = Math.floor(range * zoomFactor * 0.5);
    const newEnd = Math.ceil(range * (1 - zoomFactor * 0.5));

    setStartIndexImDatalogs(Math.max(0, newStart));
    setEndIndexImDatalogs(Math.min(imdatalogs.length - 1, newEnd));
  };

  const handleDataLimitChangeImDatalogs = (event) => {
    setDataLimitImDatalogs(parseInt(event.target.value));
  };

  const filteredDataImDatalogs = visibleDataImDatalogs.slice(
    -dataLimitImDatalogs
  );

  

  const sortedImDatalogs = [...imdatalogs].sort((a, b) => {
    const key = Object.keys(sortConfig).find(
      (k) => sortConfig[k].direction !== "asc"
    );
    if (!key) return 0;
    const direction = sortConfig[key].direction === "asc" ? 1 : -1;
    if (a[key] < b[key]) return -1 * direction;
    if (a[key] > b[key]) return 1 * direction;
    return 0;
  });

  const CustomDot = (props) => {
    const { cx, cy, payload } = props;
    if (payload.is_imputed) {
      return (
        <circle cx={cx} cy={cy} r={5} stroke="red" strokeWidth={2} fill="red" />
      );
    }

    return (
      <circle
        cx={cx}
        cy={cy}
        r={5}
        fill="black"
      />
    );
  };

  const handleSort = (key) => {
    const newDirection = sortConfig[key].direction === "asc" ? "desc" : "asc";
    setSortConfig({
      ...sortConfig,
      [key]: { direction: newDirection },
    });
  };

  const handleCorr = async () => {
    if (!startDate) {
      alert("Please select a start date.");
      return;
    }

    if (!endDate) {
      alert("Please select an end date.");
      return;
    }

    if (startDate > endDate) {
      alert("Start date cannot be after end date.");
      return;
    }

    if (!mainColumn) {
      alert("Please select Primary Data first");
      return;
    }

    setIsLoadingCorr(true);
    setShowCorrTable(true);

    try {
        const res = await fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/correlation/${selectedMarker.wellId}/${startDate}/${endDate}`, {
          method: "POST", 
          headers: {
            "Content-Type": "application/json"  // Add this to specify JSON content
          },
          body: JSON.stringify({  // Move body outside of headers
            main_col: mainColumn
          })
        });
        if (!res.ok) throw new Error(`Request failed with status ${res.status}`);

        const data = await res.json();
        console.log("Received ranking data:", data);

        // Set the metrics and models data from the response
        if (data && data.corr) {
          setCorrData(data.corr);
        } else {
          console.error("No metrics data found in response");
        }

        

    } catch (err) {
      console.error("Error fetching ranking data:", err);
      alert("Failed to fetch model ranking data. Please try again.");
    } finally {
      setIsLoadingCorr(false);
    }
  };

  const handleRequestSort = (property) => {
    const isAsc = corrOrderBy === property && corrOrder === 'asc';
    setCorrOrder(isAsc ? 'desc' : 'asc');
    setCorrOrderBy(property);
  };

  const fetchOriginalValues = async (dataPoints, wellId) => {
    // Only process anomaly-corrected points
    const anomalyPoints = dataPoints.filter(point => point.is_anomaly_corrected);

    if (anomalyPoints.length === 0) return dataPoints;

    // if (originalValueFetchedRef.current) return dataPoints; 

    try {
      const response = await fetch('https://warpo-dashboard.cse.buet.ac.bd/api/get-multiple-original-values', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          wellId: wellId,
          measurementTimes: anomalyPoints.map(point => point.mTm)
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch original values');
      }

      const data = await response.json();
      if (data.success) {
        // Create a map of original values by measurement time
        const originalValuesMap = new Map();
        data.originalValues.forEach(val => {
          originalValuesMap.set(val.mTm, val.wtr);
        });

        // originalValueFetchedRef.current = true;

        // Merge original values into the dataset
        return dataPoints.map(point => {
          if (point.is_anomaly_corrected && originalValuesMap.has(point.mTm)) {
            return {
              ...point,
              originalValue: originalValuesMap.get(point.mTm)
            };
          }
          return point;
        });
      }

      return dataPoints;
    } catch (error) {
      console.error('Error fetching original values:', error);
      return dataPoints;
    }
  };


  return (
    <div className="modal">
      <div className="modal-overlay" />
      <div className="modal-row">
        <div className="modal-content left-content">
          <div className="input-group">
            <div className="left-content-wrapper" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>

              <div className="well-info-container">
                <h2 style={{ marginBottom: "0px", marginTop: '20px', color: "red" }}>Anomaly Correction using Secondary Data</h2>
                <h2 style={{ marginBottom: "0px", marginTop: 0 }}>{selectedMarker.wellId}</h2>
                <p style={{ textAlign: "center", margin: "4px 0" }}>
                  <FaMapMarkerAlt style={{ marginRight: "8px", color: "red" }} /> {selectedMarker.union_}, {selectedMarker.upazilla}, {selectedMarker.district}, {selectedMarker.division}
                </p>
              </div>

              <div className="date-range-display">
                <p style={{ textAlign: "center", margin: "4px 0" }}>
                  <strong>Earliest Date:</strong> {earliestDate ? new Date(earliestDate).toLocaleDateString() : 'Loading...'} &nbsp; | &nbsp;
                  <strong>Latest Date:</strong> {latestDate ? new Date(latestDate).toLocaleDateString() : 'Loading...'}
                </p>
              </div>

              <Modal
                open={showMinDateModal}
                onClose={handleCloseMinDateModal}
                aria-labelledby="min-date-modal-title"
              >
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: 400,
                  backgroundColor: '#fff',
                  border: '2px solid #000',
                  boxShadow: 24,
                  padding: '20px 30px',
                  borderRadius: '8px'
                }}>
                  <Typography id="min-date-modal-title" variant="h6" component="h2" style={{ color: '#d32f2f', marginBottom: '15px' }}>
                    Insufficient Date Range
                  </Typography>
                  <Typography style={{ marginBottom: '20px', color: '#333' }}>
                    Please select an end date that is at least 2 years after the start date for proper imputation analysis.
                  </Typography>
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      onClick={handleCloseMinDateModal}
                      variant="contained"
                      style={{ backgroundColor: '#d32f2f', color: 'white' }}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              </Modal>

              <div className="date-range-container" style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "-10px" }}>
                <div className="date-inputs" style={{ display: "flex", flexDirection: "row", gap: "20px", alignItems: "flex-end" }}>
                  <div className="date-field-container">
                    <label htmlFor="start-date" style={{ color: "#85126e", marginBottom: "5px", display: "block" }}>Start Date</label>
                    <input
                      id="start-date"
                      type="date"
                      value={startDate}
                      onChange={handleStartDateChange}
                      className="date-input-field"
                      style={{
                        padding: "10px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        color: "#85126e",
                        width: "200px"
                      }}
                    />
                  </div>
                  <div className="date-field-container">
                    <label htmlFor="end-date" style={{ color: "#85126e", marginBottom: "5px", display: "block" }}>End Date</label>
                    <input
                      id="end-date"
                      type="date"
                      value={endDate}
                      onChange={handleEndDateChange}
                      className="date-input-field"
                      style={{
                        padding: "10px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        color: "#85126e",
                        width: "200px"
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* 🆕 Column Selection UI */}
              <div className="column-selection-container" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px", marginTop: "20px" }}>
                {/* Single Select */}
                <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                  <FormControl style={{ minWidth: 250 }}>
                    <InputLabel id="single-column-label">Select Primary Data</InputLabel>
                    <Select
                      labelId="single-column-label"
                      value={mainColumn}
                      onChange={handleMainColumnChange}
                      label="Select Primary Data"
                    >
                      {filteredMainColumns.map((col) => (
                        <MenuItem key={col} value={col}>{col}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <button
                    variant="contained"
                    onClick={handleCorr}
                    style={{
                      height: "60px",
                      backgroundColor: "#ff1111",
                      color: "white",
                      textTransform: "none",
                      fontSize: "20px",
                      width: "250px"
                    }}
                  >
                    Correlation of Secondary Data with Primary Data
                  </button>
                </div>

                {isLoadingCorr && (
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <CircularProgress />
                  </div>
                )}

                {showCorrTable && !isLoading && (
                  <>
                    <TableContainer component={Paper}>
                      <Table aria-label="model ranking table">
                        <TableHead>
                          <TableRow>
                              <TableCell>Secondary Data</TableCell>
                              <TableCell align="right">
                                <TableSortLabel
                                  active={corrOrderBy === 'Correlation'}
                                  direction={corrOrderBy === 'Correlation' ? corrOrder : 'desc'}
                                  onClick={() => handleRequestSort('Correlation')}
                                  style={{
                                    fontWeight: 'bold',
                                    color: corrOrderBy === 'Correlation' ? '#1976d2' : 'inherit'
                                  }}
                                >
                                  Correlation
                                </TableSortLabel>
                              </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {Object.entries(corrData)
                            .sort((a, b) => {
                              // a and b are [key, value] pairs
                              const valA = a[1];
                              const valB = b[1];
                              return corrOrder === 'asc' ? valA - valB : valB - valA;
                            })
                            .map(([key, value]) => (
                              <TableRow key={key}>
                                <TableCell component="th" scope="row">
                                  {key}
                                </TableCell>
                                <TableCell align="right" style={{ color: corrOrderBy === 'Correlation' ? '#1976d2' : 'inherit' }}>
                                  {typeof value === 'number' ? value.toFixed(4) : value}
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                )}

                {/* Multi Select */}
                <FormControl style={{ minWidth: 250 }}>
                  <InputLabel id="multi-column-label">Select Secondary Data</InputLabel>
                  <Select
                    labelId="multi-column-label"
                    multiple
                    value={supportColumns}
                    onChange={(e) => setSupportColumns(e.target.value)}
                    input={<OutlinedInput label="Select Secondary Data" />}
                    renderValue={(selected) => selected.join(', ')}
                  >
                    {filteredSupportColumns.map((col) => (
                      <MenuItem key={col} value={col}>
                        <Checkbox checked={supportColumns.includes(col)} />
                        <ListItemText primary={col} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>

              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px', 
                marginBottom: '5px', 
                width: '100%'
              }}>
                <FormControl variant="outlined" style={{ width: '600px' }}> {/* Reduced width */}
                  <InputLabel id="version-label">Select Version of Imputation</InputLabel>
                  <Select
                    labelId="version-label"
                    value={selectedVersion}
                    onChange={handleVersionChange}
                    label="Select Version"
                    fullWidth
                    size="small" 
                  >
                    {/* Add Raw Data as version 0 */}
                    <MenuItem key="raw-data" value="0">
                      Version 0 - Raw Data
                    </MenuItem>
                    {versions.map((version) => (
                      <MenuItem key={version.version_number} value={version.version_number}>
                        {`[${version.measurement_parameters.join(', ')}] Version ${version.version_number} - ${format(new Date(version.update_time), 'dd--MM--yyyy HH:mm:ss')}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleDetailsButtonClick}
                  size="small" 
                >
                  Details
                </Button>
              </div>

              {/* Version details modal*/}
              <Modal open={isModalOpen} onClose={handleCloseModal}>
                <div
                  style={{
                    position: 'absolute',
                    top: '53%',
                    left: '74%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'cyan',
                    color: 'black',
                    padding: '15px', 
                    borderRadius: '8px',
                    minWidth: '380px', 
                  }}
                >
                  <Typography variant="h6" style={{ fontSize: "16px", margin: "0 0 8px 0" }}>Version Details</Typography>

                  {versionDetails ? (
                    <div style={{ fontSize: "14px" }}> 
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}><strong>Well ID:</strong> {versionDetails.wellId}</p>
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}><strong>Version Number:</strong> {versionDetails.version_number}</p>
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}><strong>Update Time:</strong> {formatDate(versionDetails.update_time)}</p>
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}>
                        <strong>Date Range:</strong>  {formatDate(versionDetails.start_date, 'd MMM yyyy')} to{' '}
                        {formatDate(versionDetails.end_date, 'd MMM yyyy')}
                      </p>

                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}><strong>Name:</strong> {versionDetails.name}</p>
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}><strong>Designation:</strong> {versionDetails.designation}</p>
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}><strong>Email:</strong> {versionDetails.email}</p>
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}><strong>Contact No:</strong> {versionDetails.contact_no}</p>
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}><strong>Comments:</strong> {versionDetails.comments}</p>
                    </div>
                  ) : (
                    <p style={{ fontSize: "14px" }}>Loading...</p>
                  )}

                  {/* Close Button */}
                  <Button
                    onClick={handleCloseModal}
                    style={{ backgroundColor: 'red', color: 'white', width: '90px', height: '32px', fontSize: '13px', marginTop: '6px' }}
                  >
                    Close
                  </Button>
                </div>
              </Modal>

              <div className="form-group" style={{
                width: "100%",
                textAlign: "center"
              }}>
                <h3 style={{ marginBottom: "5px", fontSize: "15px" }}>Maximum Deviation Percentage</h3>
                <TextField
                  label="Percentage"
                  variant="outlined"
                  value={AnRate}
                  onChange={handleAnRateChange}
                  className="rate-text-field"
                  fullWidth
                  size="small" 
                />
              </div>
            </div>
          </div>

          <div className="action-buttons" style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            marginTop: "20px"
          }}>
            <Button
              variant="contained"
              onClick={handleSubmit}
              className="button submit-button"
              style={{
                height: "40px",
                width: "170px",
                textTransform: "none",
                fontSize: "16px"
              }}
            >
              Submit
            </Button>
          </div>
        </div>

        
        <div className="modal-content right-content" style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          height: "100vh",
          textAlign: "center",
          padding: "10px",
          gap: "5px",
        }}>
          <div style={{ flexShrink: 0 }}>
            <div className="button-group" style={{ marginBottom: '0px', marginTop: '35px' }}>
              <Button
                variant="contained"
                onClick={imdownloadAsCSV}
                className="blue-button"
                size="small"
                style={{ margin: "0 2px" }}
              >
                Download as CSV
              </Button>
              <Button
                variant="contained"
                onClick={imdownloadAsPDF}
                className="green-button"
                size="small"
                style={{ margin: "0 2px" }}
              >
                Download as PDF
              </Button>
              <Button
                variant="contained"
                onClick={handleCloseMultiColAnModal}
                className="red-button"
                size="small"
                style={{ margin: "0 2px" }}
              >
                Close Window
              </Button>
            </div>

            <div className="well-info-container" style={{ marginTop: "5px", marginBottom: "10px" }}>
              <h2 style={{ margin: 0, fontSize: "18px", marginTop: "10px" }}>{selectedMarker.wellId}</h2>
              <p style={{ marginBottom: '5px', fontSize: "14px", textAlign: "center" }}>
                <FaMapMarkerAlt style={{ marginRight: "8px", color: "red" }} /> {selectedMarker.union_}, {selectedMarker.upazilla}, {selectedMarker.district}, {selectedMarker.division}
              </p>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '5px', justifyContent: 'center' }}>
              <FormControl variant="outlined" style={{ width: '600px' }}> 
                <InputLabel id="version-label">Select Version of Anomaly Correction</InputLabel>
                <Select
                  labelId="version-label"
                  value={selectedVersionAnom}
                  onChange={handleVersionChangeAnom}
                  label="Select Version"
                  fullWidth
                  size="small" 
                >
                  {versionsanom.map((version) => (
                    <MenuItem key={version.version_number} value={version.version_number}>
                      {`[${version.measurement_parameters.join(', ')}] Version ${version.version_number} - ${format(new Date(version.update_time), 'dd--MM--yyyy HH:mm:ss')}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button
                variant="contained"
                color="primary"
                  onClick={handleDetailsButtonClickAnom}
                size="small"
              >
                Details
              </Button>
            </div>
          </div>

          <Modal open={isModalOpen} onClose={handleCloseModal}>
            <div
              style={{
                position: 'absolute',
                top: '53%',
                left: '74%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: 'cyan',
                color: 'black',
                padding: '20px',
                borderRadius: '8px',
                minWidth: '400px',
              }}
            >
              <Typography variant="h6">Version Details</Typography>

              {versionDetails ? (
                <div>
                  <p style={{ color: 'black', fontSize: '16px' }}><strong>Well ID:</strong> {versionDetails.wellId}</p>
                  <p style={{ color: 'black', fontSize: '16px' }}><strong>Version Number:</strong> {versionDetails.version_number}</p>
                  <p style={{ color: 'black', fontSize: '16px' }}><strong>Update Time:</strong> {formatDate(versionDetails.update_time)}</p>
                  <p style={{ color: 'black', fontSize: '16px' }}>
                    <strong>Date Range:</strong>  {formatDate(versionDetails.start_date, 'd MMM yyyy')} to{' '}
                    {formatDate(versionDetails.end_date, 'd MMM yyyy')}
                  </p>

                  <p style={{ color: 'black', fontSize: '16px' }}><strong>Name:</strong> {versionDetails.name}</p>
                  <p style={{ color: 'black', fontSize: '16px' }}><strong>Designation:</strong> {versionDetails.designation}</p>
                  <p style={{ color: 'black', fontSize: '16px' }}><strong>Email:</strong> {versionDetails.email}</p>
                  <p style={{ color: 'black', fontSize: '16px' }}><strong>Contact No:</strong> {versionDetails.contact_no}</p>
                  <p style={{ color: 'black', fontSize: '16px' }}><strong>Comments:</strong> {versionDetails.comments}</p>
                </div>
              ) : (
                <p>Loading...</p>
              )}

              {/* Close Button */}
              <Button
                onClick={handleCloseModal}
                style={{ backgroundColor: 'red', color: 'white', width: '100px' }}
              >
                Close
              </Button>
            </div>
          </Modal>

          <div style={{ flex: 1, overflowY: 'auto', padding: '10px', marginLeft: '10px', marginRight: '10px' }}>
          
            <div className="graph-container" style={{ marginBottom: '5px', width: "100%" }}>

              <div className="button-group" style={{ display: "flex", gap: "3px", justifyContent: "center", marginBottom: "5px" }}>

                <Button
                  variant="contained"
                  onClick={resetZoomImDatalogs}
                  className="zoom-button"
                  size="small"
                >
                  Reset Zoom
                </Button>
                <Button
                  variant="contained"
                  onClick={handleDownload}
                  className="zoom-button"
                  size="small"
                >
                  Save Image
                </Button>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  width: "100%",
                  marginBottom: "5px"
                }}
              >
                <Slider
                  value={zoomLevelImDatalogs}
                  onChange={handleZoomImDatalogs}
                  aria-labelledby="zoom-slider"
                  min={0}
                  max={100}
                  step={5}
                  valueLabelDisplay="auto"
                  style={{ flex: 1 }}
                  size="small"
                />
                <h3 style={{ minWidth: "40px", margin: 0, fontSize: "14px" }}>
                  {/* {zoomLevelImDatalogs}% */}
                </h3>
              </div>

              <div className="filter-container" style={{ display: "flex", alignItems: "center", gap: "10px", justifyContent: "center", marginBottom: "5px" }}>
                <h3 className="filter-label">Filter Data: </h3>
                <FormControl
                  variant="outlined"
                  size="small"
                  className="filter-dropdown"
                >
                  <InputLabel>Data Points</InputLabel>
                  <Select
                    value={dataLimitImDatalogs}
                    onChange={handleDataLimitChangeImDatalogs}
                    label="Data Points"
                  >
                    <MenuItem value={10}>Last 10</MenuItem>
                    <MenuItem value={50}>Last 50</MenuItem>
                    <MenuItem value={100}>Last 100</MenuItem>
                    <MenuItem value={visibleDataImDatalogs.length}>
                      All
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>

              {/*Revert confirmation modal */}
              <Modal open={isRevertModalOpen} onClose={handleCloseRevertModal}>
                <div
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'white',
                    color: 'black',
                    padding: '15px', 
                    borderRadius: '8px',
                    minWidth: '380px', 
                  }}
                >
                  <Typography variant="h6" style={{ fontSize: "16px", marginBottom: "10px" }}>Anomaly Correction</Typography>
  
                  {selectedDataPoint && (
                    <div style={{ fontSize: "14px" }}>
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}>
                        <strong>Time:</strong> {formatDate(selectedDataPoint.mTm)}
                      </p>
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}>
                        <strong>Anomaly Corrected Value:</strong> {selectedDataPoint.wtr} meter
                      </p>
                      {isLoadingOriginal ? (
                        <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}>Loading original value...</p>
                      ) : originalError ? (
                        <p style={{ color: 'red', fontSize: '14px', margin: '4px 0' }}>
                          Error loading original value: {originalError}
                        </p>
                      ) : originalValue !== null ? (
                        <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}>
                          <strong>Original Value:</strong> {originalValue} meter
                        </p>
                      ) : (
                        <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}>
                          Original value is null
                        </p>
                      )}
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}>
                        If you want to revert this anomaly corrected data to the original value, please click the "Revert to Original" button below.
                      </p>
                    </div>
                  )}
  
                  {/* Action buttons */}
                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '12px' }}>
                    <Button
                      onClick={handleCloseRevertModal}
                      style={{ backgroundColor: 'grey', color: 'white', height: '32px', fontSize: '13px' }}
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={handleRevertAnomaly}
                      style={{ backgroundColor: 'red', color: 'white', height: '32px', fontSize: '13px' }}
                      disabled={isLoadingOriginal}
                    >
                      Revert to Original
                    </Button>
                  </div>
                </div>
              </Modal>
  
              {/* Second confirmation modal */}
              <Modal open={isConfirmRevertModalOpen} onClose={handleCloseConfirmRevertModal}>
                <div
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'white',
                    color: 'black',
                    padding: '15px',
                    borderRadius: '8px',
                    minWidth: '380px', 
                  }}
                >
                  <Typography variant="h6" style={{ fontSize: "16px", marginBottom: "10px" }}>Confirm Reversion</Typography>
  
                  {selectedDataPoint && (
                    <div style={{ fontSize: "14px" }}>
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}>
                        This action cannot be undone. The data point will be restored to its original value.
                      </p>
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0', fontWeight: 'bold' }}>
                        Are you sure you want to revert this anomaly corrected value?
                      </p>
                    </div>
                  )}
  
                  {/* Action buttons */}
                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '12px' }}>
                    <Button
                      onClick={handleCloseConfirmRevertModal}
                      style={{ backgroundColor: 'grey', color: 'white', height: '32px', fontSize: '13px' }}
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={handleConfirmRevert}
                      style={{ backgroundColor: 'red', color: 'white', height: '32px', fontSize: '13px' }}
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              </Modal>

              <div ref={chartRef}>
                <ResponsiveContainer width="100%" height={320}>
                  <LineChart
                    data={filteredDataImDatalogs.length > 0 ? filteredDataImDatalogs : []}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="mTm"
                      tickFormatter={(tick) => new Date(tick).toLocaleDateString()}
                      label={{
                        value: "Measurement Time",
                        position: "insideBottom",
                        offset: 0,
                        dy: 1,
                        fontSize: 12
                      }}
                      tick={{ fontSize: 10 }}
                    />
                    <YAxis
                      domain={[0, 12]}
                      label={{
                        value: "Water Level(meter)",
                        angle: -90,
                        position: "insideLeft",
                        dy: 60,
                        fontSize: 12
                      }}
                      tick={{ fontSize: 10 }}
                    />
                    <Tooltip
                      contentStyle={{ color: "#fff" }}
                      labelFormatter={(value) => `Time: ${formatDate(value)}`}
                      formatter={(value, name) => {
                        if (name === "originalValue") {
                          return [`${value}`, "Original Value"];
                        }
                        return [`${value}`, `${name.toUpperCase()}`];
                      }}
                    />

                    {/* Add a line for original values */}
                    <Line
                      type="monotone"
                      dataKey="originalValue"
                      stroke="purple"  // Green color for original values
                      strokeWidth={1.5}
                      dot={{ r: 5, fill: "purple", stroke: "purple", strokeWidth: 1 }}
                      activeDot={false}  // ⛔ disable misleading hover marker
                      name="originalValue"
                      connectNulls={true}  // Skip points without originalValue (non-anomaly points)
                    />

                    {/* Main line for current values (either corrected or normal) */}
                    <Line
                      type="monotone"
                      dataKey={selectedMetric}
                      stroke="#000000"
                      strokeWidth={1.5}
                      dot={<CustomDotAnomaly onClick={handleAnomalyPointClick} />}
                    />

                    <Brush
                      dataKey="mTm"
                      height={40}
                      stroke="#8884d8"
                      y={280}
                      tickFormatter={(tick) => new Date(tick).toLocaleString()}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>

            <p style={{ margin: '2px 0' }}>
              Click on the cell to sort it ASC <FaArrowUp /> or DESC <FaArrowDown />
            </p>


            <TableContainer
              component={Paper}
              sx={{
                backgroundColor: "#000000",
                padding: "10px",
                borderRadius: "8px",
              }}
            >
              <Table sx={{ minWidth: 550 }}>
                <TableHead sx={{ backgroundColor: "#ffffff" }}>
                  <TableRow>
                    <TableCell style={{ padding: "6px 8px", fontSize: "13px" }}>
                      <TableSortLabel
                        active={sortConfig.mTm.direction !== "asc"}
                        direction={sortConfig.mTm.direction}
                        onClick={() => handleSort("mTm")}
                      >
                        Measurement Time
                      </TableSortLabel>
                    </TableCell>
                    <TableCell style={{ padding: "6px 8px", fontSize: "13px" }}>
                      <TableSortLabel
                        active={sortConfig.wtr.direction !== "asc"}
                        direction={sortConfig.wtr.direction}
                        onClick={() => handleSort("wtr")}
                      >
                        Water Level
                      </TableSortLabel>
                    </TableCell>
                    <TableCell style={{ padding: "6px 8px", fontSize: "13px" }}>
                      <TableSortLabel>
                        Original Value
                      </TableSortLabel>
                    </TableCell>
                    <TableCell style={{ padding: "6px 8px", fontSize: "13px" }}>
                      <TableSortLabel>
                        Is Anomaly Corrected?
                      </TableSortLabel>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedImDatalogs.map((datalog) => (
                    <TableRow
                      key={datalog.id}
                      sx={{
                        backgroundColor: datalog.is_anomaly_corrected
                          ? "#FF9800" // Orange if anomaly corrected
                          : "#1a1a1a", // Dark gray otherwise
                        "&:nth-of-type(odd)": {
                          backgroundColor: datalog.is_anomaly_corrected
                            ? "#FF9800" // Orange if anomaly corrected
                            : "#262626", // Slightly lighter gray otherwise
                        },
                      }}
                    >
                      <TableCell sx={{ color: "#ffffff", padding: "4px 8px", fontSize: "12px" }}>
                        {datalog.mTm}
                      </TableCell>
                      <TableCell sx={{ color: "#ffffff", padding: "4px 8px", fontSize: "12px" }}>
                        {datalog.wtr}
                      </TableCell>
                      <TableCell sx={{ color: "#ffffff", padding: "4px 8px", fontSize: "12px" }}>
                        {/* {datalog.is_anomaly_corrected ? (
                          <span style={{ color: "#00ff00" }}>{datalog.originalValue || "N/A"}</span>
                        ) : (
                          "N/A"
                        )} */}
                        {datalog.originalValue}
                      </TableCell>
                      <TableCell sx={{ color: "#ffffff", padding: "4px 8px", fontSize: "12px" }}>
                        {datalog.is_anomaly_corrected ? "Yes" : "No"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>  
        </div>
      </div>
    </div>
  );
};

export default MultiColAnomalyLog;